import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Modal, FormLayout, DropZone, Button, ChoiceList, ButtonGroup, Tabs } from '@shopify/polaris';
import { tAttribute } from '@utils';

import AutocompleteSearch from '@presentational/AutocompleteSearch';
import ImageDropZone from '@presentational/ImageDropZone';
import BasicTextField from '@presentational/BasicTextField';

const propTypes = {
  formikProps: PropTypes.object.isRequired,
  resourceTypes: PropTypes.object.isRequired,

  handleShopifyResourceSelection: PropTypes.func.isRequired,
  handleUrlChange: PropTypes.func.isRequired,
  handleImageDrop: PropTypes.func.isRequired,
  handleImageRemove: PropTypes.func.isRequired,

  fetchCollectionURL: PropTypes.string.isRequired,
  fetchProductURL: PropTypes.string.isRequired,
}

const defaultProps = {

}

const BannerGeneralForm = (props) => {
  const [selectedSource, setSelectedSource] = useState([ props.resourceTypes.COLLECTION ]);
  const handleSourceChange = useCallback((value) => setSelectedSource(value), []);
  
  const { formikProps, resourceTypes, handleShopifyResourceSelection } = props
  return (
    <FormLayout>
      <ChoiceList
        title="Vincular a:"
        choices={[
          {label: 'Shopify Collection', value: resourceTypes.COLLECTION },
          {label: 'Shopify Product', value: resourceTypes.PRODUCT },
        ]}
        selected={ selectedSource }
        onChange={handleSourceChange}
      />
      { selectedSource == resourceTypes.COLLECTION &&
        <AutocompleteSearch
          placeholder="Buscar collection..."
          apiURL={ props.fetchCollectionURL }
          onSelectionCallback={ (value, item) => handleShopifyResourceSelection(value, item, formikProps, resourceTypes.COLLECTION) }
          itemLabelAccessor="title"
          itemValueAccessor="id"
        />
      }
      { selectedSource == resourceTypes.PRODUCT &&
        <AutocompleteSearch
          placeholder="Buscar producto..."
          apiURL={ props.fetchProductURL }
          onSelectionCallback={ (value, item) => handleShopifyResourceSelection(value, item, formikProps, resourceTypes.PRODUCT) }
          itemLabelAccessor="title"
          itemValueAccessor="id"
        />
      }
      
      <FormLayout.Group>
        <BasicTextField
            name="url"
            readOnly
            label={ tAttribute("banner", "url") }
            handleChange={ (value, id) =>  handleUrlChange(id, value, formikProps) }
            values={ formikProps.values }
            errors={ formikProps.errors }
        />
        <BasicTextField
          name="shopify_resource_id"
          label={ tAttribute("banner", "shopify_resource_id") }
          handleChange={ (value, id) => formikProps.setFieldValue(id, value) }
          readOnly
          values={ formikProps.values }
          errors={ formikProps.errors }
        />
      </FormLayout.Group>
      <BasicTextField
        name="url_web"
        placeholder="https://www.store.com/some-url?utm_source=banners&utm_medium=xyz&utm_campaign=CampaignName"
        label={ tAttribute("banner", "url_web") }
        handleChange={ (value, id) => formikProps.setFieldValue(id, value) }
        values={ formikProps.values }
        errors={ formikProps.errors }
        helpText="URL aplica solo para web y sobrescribe la selección de Collection o Product"
      />
      <BasicTextField
        name="alt"
        placeholder="Promociones de temporada"
        label={ tAttribute("banner", "alt") }
        handleChange={ (value, id) => formikProps.setFieldValue(id, value) }
        values={ formikProps.values }
        errors={ formikProps.errors }
      />
      <ImageDropZone
        onDrop={ (_dropFiles, acceptedFiles, _rejectedFiles) => props.handleImageDrop(acceptedFiles, formikProps, "image_desktop") }
        label={ "Imagen Desktop" }
        imageFile={ formikProps.values.image_desktop_upload || formikProps.values.image_desktop_preview  }
        onDelete={ () => props.handleImageRemove(formikProps, "image_desktop") }
      />
      
      <ImageDropZone
        onDrop={ (_dropFiles, acceptedFiles, _rejectedFiles) => props.handleImageDrop(acceptedFiles, formikProps, "image_mobile") }
        label={ "Imagen Mobile" }
        imageFile={ formikProps.values.image_mobile_upload || formikProps.values.image_mobile_preview  }
        onDelete={ () => props.handleImageRemove(formikProps, "image_mobile") }
      />
    </FormLayout>
  )
};

BannerGeneralForm.propTypes = propTypes;
BannerGeneralForm.defaultProps = defaultProps;

export default BannerGeneralForm;            